import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { motion } from "framer-motion";

const Opiniones = () => {
  const opiniones = [
    {
      fecha: "Viernes 3 de Septiembre , 2021",
      opinion:
      " Lavar la ropa ya no es un problema para mí, ya que en menos de una hora, mi ropa está bien lavada ",
      nombre: "Norberto Flores",
      cargo: "Estudiante, Puebla",
    },
    {
      fecha: "Martes 5 de Abril , 2022",
      opinion:
      " Soy nueva en la ciudad y tener una lavandería a la mano ha sido de gran apoyo para mí, además el servicio es inmejorable ",
      nombre: "Alonso Casas",
      cargo: "CP, Veracruz",
    },
    {
      fecha: "Jueves 9 de Diciembre , 2021",
      opinion:
      " Mi ropa sigue conservando su calidad después de cada lavada, además el servicio es muy rápido ",
      nombre: "Mariana Saldaña",
      cargo: "Licenciada en Administración de Empresas, Puebla",
    },
  ];

  return (
    <div className="w-full h-screen flex flex-col items-center justify-center px-4 md:px-24">
      <motion.h2
        className="text-4xl text-teal-500 font-bold mb-6 md:py-32"
        initial={{ y: -40, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 1 }}
      >
        Por qué la gente confía en nosotros
      </motion.h2>

      <div className="h-1 w-full bg-blue-700 mb-8" />

      <Swiper
        modules={[Pagination, Autoplay]}
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000 }}
        loop={true}
        className="w-full md:w-3/4 h-full"
      >
        {opiniones.map((op, idx) => (
          <SwiperSlide key={idx}>
            <motion.div
              className="flex flex-col items-center gap-4 text-center px-6 h-full justify-around"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <p className="font-light text-gray-500">{op.fecha}</p>
              <h2 className="text-xl md:text-2xl text-teal-500 font-semibold leading-relaxed">
                “{op.opinion}”
              </h2>

              <div className="bg-teal-500 px-6 py-4 rounded-full text-white text-center">
                <p className="text-lg font-medium">{op.nombre}</p>
                <p className="text-sm">{op.cargo}</p>
              </div>
            </motion.div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Opiniones;
